@let img = image();
@let details = description();

<div class="flex gap-8">
    <div>
        @if (img) {
            <big-ui-picture
                class="block aspect-square w-20 overflow-hidden rounded-2xl md:w-30"
                [model]="img" />
        } @else {
            <big-ui-company-logo
                [showLogo]="'mobile'"
                class="text-primary-500 m-2.5 block w-20 md:w-25" />
        }
    </div>
    <div class="flex flex-col gap-2">
        <strong class="text-primary-500">{{ 'app.authorBox.writtenBy' | transloco }}</strong>
        <div class="h4 mb-0">{{ name() ?? ('app.authorBox.fallbackName' | transloco) }}</div>
        @if (details) {
            <div [innerHTML]="details | sanitize: securityContext"></div>
        }
    </div>
</div>
